import FrIcon from '../../assets/drapeauxCarres/FRA.svg'
import GrcIcon from '../../assets/drapeauxCarres/grc.svg'
import ItaIcon from '../../assets/drapeauxCarres/ita.svg'
import NldIcon from '../../assets/drapeauxCarres/nld.svg'
import PrtIcon from '../../assets/drapeauxCarres/prt.svg'
import LuxIcon from '../../assets/drapeauxCarres/lux.svg'
import GerIcon from '../../assets/drapeauxCarres/ger.svg'
import DeuIcon from '../../assets/drapeauxCarres/deu.svg'
import AutIcon from '../../assets/drapeauxCarres/aut.svg'
import Mali from '../../assets/drapeauxCarres/mali.svg'
import Nigeria from '../../assets/drapeauxCarres/nigeria.svg'
import Kenya from '../../assets/drapeauxCarres/kenya.svg'
import BelIcon from '../../assets/drapeauxCarres/bel.svg'
import drapeauTunisie from '../../assets/drapeauxCarres/drapeauTunisie.svg'
import drapeauMaroc from '../../assets/drapeauxCarres/flagMaroc.svg'
import drapeauAlge from '../../assets/drapeauxCarres/drapeauAlge.svg'
import drapeauSenegal from '../../assets/drapeauxCarres/drapeauSenegal.svg'

import {FlagPakistan, FlagBangladesh, FlagTurk, Suisse, Chine, UK} from '../../assets/drapeauxCarres/index'
import FreeSen from '../../assets/freeSen.svg'
import inwiMaroc from '../../assets/inwiMaroc.svg'
import telecomMaroc from '../../assets/telecomMaroc.svg'
import imageOoredooRecharge from '../../assets/imageOoredooRecharge.svg'
import imageTelecom from '../../assets/imageTelecom.svg'
import { TimIT, PosteFR, Lyca, FreeFR, Vodafone, Windtre, TelekomDE, Telefonica, 
  Proximus,Orange, TelenetBase, TMobileNL, KPN, PostLux, Cosmote, Nova, MEO, NOS,
   Movistar, mobilisAlg , Djezzi, ExpressoSen,
   jazz, Zong, Telenor,
   Grameenphone, Banglalik, Robi,  Turkcell,
   TurkTelekom, MoovAfricaMali, TelecelMali,
   MNTNig, GlobalCom, AirtelNig,
   SafarieCom, TelkomKen,
   Salt,SwissCon,Sunrise,
   ThreeUK, O2UK,
   UnicomCH,TelecomCH,MobileCH
  } from 'assets/operateurRecharge/index'
export const countries = [
 
    { image: drapeauTunisie, value: 'Tunisie',countryCode:'TUN', digits:8 , codeIso:'TN', code: '+216', operator: [{
      code: 'TUTN',
      value: 'Ooredoo Tunisie',
      image: imageOoredooRecharge,
      styleLogo:'sm:w-[72px] h-auto'
      },
      {
        code: 'ORTN',
        value: 'Orange Tunisie',
        image: Orange,
        styleLogo:'sm:w-[30px] h-auto'

        },
        // {
        //   code: 'TWTN',
        //   value: 'Tunisie Télécom',
        //   image: imageTelecom,
        //   styleLogo:'sm:w-[52px] h-auto'
        // },
      ]
     },
     
    { image: drapeauMaroc, value: 'Maroc',countryCode:'MAC', digits:9 , codeIso:'MA', code: '+212',
     operator:[
      {
        code: 'INMA',
        value: 'Inwi',
        image: inwiMaroc,
        styleLogo:'sm:w-[58px] h-auto'
      },
      {
        code: 'ORMA',
        value: 'Orange Maroc',
        image: Orange,
        styleLogo:'sm:w-[30px] h-auto'
      },
      {
        code: 'MOMA',
        value: 'Maroc Telecom',
        image: telecomMaroc,
        styleLogo:'sm:w-[56px] h-auto'
      },
    ] },
    
    { image: drapeauAlge, value: 'Algérie',countryCode:'DZA', digits:9 , codeIso:'DZ', code: '+213',
        operator:[
      {
        code: 'OODZ',
        value: 'Ooredoo Algérie',
        image: imageOoredooRecharge,
        styleLogo:'sm:w-[72px] h-auto'
      },
      {
        code: 'DJDZ',
        value: 'Djezzi',
        image: Djezzi,
        styleLogo:'sm:w-[35px] h-auto'
      },
      {
        code: 'MDDZ',
        value: 'Mobilis',
        image: mobilisAlg,
        styleLogo:'sm:w-[66px] h-auto'
      },
    ]
     },

    { image: drapeauSenegal, value: 'Sénégal',countryCode:'SEN', digits:9 , codeIso:'SN', code: '+221',
        operator:[
      {
        code: 'TISN',
        value: 'Free',
        image: FreeSen,
        styleLogo:'sm:w-[67px] h-auto'
      },
      {
        code: 'ORSN',
        value: 'Orange Sénégal',
        image: Orange,
        styleLogo:'sm:w-[30px] h-auto'
      },
      {
        code: 'XPSN',
        value: 'Expresso',
        image: ExpressoSen,
        styleLogo:'sm:w-[74px] h-auto'
      },
    ]
     },
    { image: FlagPakistan, value: "Pakistan",countryCode:'PAK', digits: 10 , codeIso:'PK', code: "+92",
        operator:[
          {
          code: 'MBPK',
          value: 'Jazz',
          image: jazz,
          styleLogo:'sm:w-[43px] h-auto'
        },
        {
          code: 'ZNPK',
          value: 'Zong',
          image: Zong,
          styleLogo:'sm:w-[91px] h-auto'
        },
        {
          code: 'TPPK',
          value: 'Telenor',
          image: Telenor,
          styleLogo:'sm:w-[72px] h-auto'
        },
        ]
     },
     { image: FlagBangladesh, value: "Bangladesh",countryCode:'BGD', digits: 10 , codeIso:'BD', code: "+880",
        operator:[
          {
          code: 'GEBD',
          value: 'Grameenphone',
          image: Grameenphone,
          styleLogo:'sm:w-[74px] h-auto'
        },
        {
          code: 'BGBD',
          value: 'Banglalink',
          image: Banglalik,
          styleLogo:'sm:w-[81px] h-auto'
        },
        {
          code: 'RLBD',
          value: 'Robi',
          image: Robi,
          styleLogo:'sm:w-[63px] h-auto'
        },
      ]
      },
       { image: FlagTurk, value: "Turquie",countryCode:'TUR', digits: 10 , codeIso:'TR', code: "+90",
        operator:[
          {
          code: 'TZTR',
          value: 'Turkcell',
          image: Turkcell,
          styleLogo:'sm:w-[120px] h-auto'
        },
        {
          code: 'VFTR',
          value: 'Vodafone',
          image: Vodafone,
          styleLogo:'sm:w-[110px] h-auto'
        },
        {
          code: 'AVTR',
          value: 'Turk Telekom',
          image: TurkTelekom,
          styleLogo:'sm:w-[120px] h-auto'
        },
      ]
    },


    { image: FrIcon, value: "France",countryCode:'FRA', digits: 9, codeIso:'FR', code: "+33",
        operator:[
      {
        code: 'ORFR',
        value: 'Orange',
        image: Orange,
        styleLogo:'sm:w-[30px] h-auto'
      },
      {
        // code: 'LAFR',
        code:'LYFR',

        value: 'Lyca Mobile',
        image: Lyca,
        styleLogo:'sm:w-[62px] h-auto'
      },
      {
        code: '1E3143FR',
        value: 'Free Mobile',
        image: FreeFR,
        styleLogo:'sm:w-[66px] h-auto'
      },
      {
        code: 'LPFR',
        value: 'La Poste Mobile',
        image: PosteFR,
        styleLogo:'sm:w-[60px] h-auto'
      },
    ]
     },
     
    { image: GrcIcon, value: "Grèce",countryCode:'GRC', digits:10 , codeIso:'GR', code: "+30",
        operator:[
         {
        code: 'CFGR',
        value: 'Cosmote',
        image: Cosmote,
        styleLogo:'sm:w-[77px] h-auto'
      },
      {
        code: 'VFGR',
        value: 'Vodafone',
        image: Vodafone,
        styleLogo:'sm:w-[73px] h-auto'
      },
      {
        code: 'WIGR',
        value: 'Nova',
        image: Nova,
        styleLogo:'sm:w-[65px] h-auto'
      },
        ]
     },

    { image: ItaIcon, value: "Italie",countryCode:'ITA', digits:[10] , codeIso:'IT', code: "+39",
        operator:[
          {
        code: 'IMIT',
        value: 'TIM',
        image: TimIT,
        styleLogo:'sm:w-[67px] h-auto'
      },
      {
        code: 'VFIT',
        value: 'Vodafone',
        image: Vodafone,
        styleLogo:'sm:w-[73px] h-auto'
      },
      {
        code: 'WIIT',
        value: 'Wind Tre',
        image: Windtre,
        styleLogo:'sm:w-[60px] h-auto'
      },
        ]
     },

    { image: NldIcon, value: "Pays Bas",countryCode:'NLD', digits:9 , codeIso:'NL', code: "+31",
        operator:[
      {
        code: '0KNL',
        value: 'KPN',
        image: KPN,
        styleLogo:'sm:w-[68px] h-auto'
      },
      {
        code: 'VFNL',
        value: 'Vodafone',
        image: Vodafone,
        styleLogo:'sm:w-[74px] h-auto'
      },
      {
        code: 'TLNL',
        value: 'T- Mobile',
        image: TMobileNL,
        styleLogo:'sm:w-[74px] h-auto'
      },
        ]
     },


    { image: LuxIcon, value: "Luxembourg",countryCode:'LUX', digits:9 , codeIso:'LU', code: "+352",
        operator:[
          {
        code: '0LLU',
        value: 'POST Luxembourg ',
        image: PostLux,
        styleLogo:'sm:w-[48px] h-auto'
      },
      {
        code: 'ORLU',
        value: 'Orange',
        image: Orange,
        styleLogo:'sm:w-[33px] h-auto'
      },
      
        ]
     },

    { image: GerIcon, value: "Allemagne",countryCode:'DEU', digits: 11, codeIso:'DE', code: "+49",
        operator:[
          {
          code: 'TLDE',
          value: 'Deutsche Telekom',
          image: TelekomDE,
          styleLogo:'sm:w-[78px] h-auto'
        },
        {
          code: 'VFDE',
          value: 'Vodafone',
          image: Vodafone,
          styleLogo:'sm:w-[73px] h-auto'
        },
        {
          code: 'O2DE',
          value: '(O2) Telefónica',
          image: Telefonica,
          styleLogo:'sm:w-[73px] h-auto'
        },
        ]
     },
 
    { image: DeuIcon, value: "Espagne",countryCode:'ESP', digits:9 , codeIso:'ES', code: "+34",
        operator:[
          {
          code: 'TFES',
          value: 'Movistar',
          image: Movistar,
          styleLogo:'sm:w-[76px] h-auto'
        },
        {
          code: 'VFES',
          value: 'Vodafone',
          image: Vodafone,
          styleLogo:'sm:w-[73px] h-auto'
        },
        {
          code: 'ORES',
          value: 'Orange',
          image: Orange,
          styleLogo:'sm:w-[33px] h-auto'
        },
        ]
     },
    { image: BelIcon, value: "Belgique",countryCode:'BEL', digits: 8 , codeIso:'BE', code: "+32",
        operator:[
          {
          code: 'PXBE',
          value: 'Proximus',
          image: Proximus,
          styleLogo:'sm:w-[68px] h-auto'
        },
        {
          code: 'ORBE',
          value: 'Orange',
          image: Orange,
          styleLogo:'sm:w-[33px] h-auto'
        },
        {
          code: 'B5BE',
          value: 'BASE',
          image: TelenetBase,
          styleLogo:'sm:w-[59px] h-auto'
        },
        ]
     },


    { image: Mali, value: 'Mali',countryCode:'MLI', digits:8 , codeIso:'ML', code: '+223',
        operator:[
      {
        code: 'ORML',
        value: 'Orange Mali',
        image: Orange,
        styleLogo:'sm:w-[30px] h-auto'
      },
      {
        code: 'XMML',
        value: 'Moov Africa Mali',
        image: MoovAfricaMali,
        styleLogo:'sm:w-[68px] h-auto'
      },
      
      {
        code: 'LTML',
        value: 'Telecel Mali',
        image: TelecelMali,
        styleLogo:'sm:w-[44px] h-auto'
      },
    ]
     },

     { image: Nigeria, value: 'Nigeria',countryCode:'NGA', digits:10 , codeIso:'NG', code: '+234',
        operator:[
      {
        code: 'MTNG',
        value: 'MTN Nigeria ',
        image: MNTNig,
        styleLogo:'sm:w-[51px] h-auto'
      },
      {
        code: 'ZANG',
        value: 'Airtel Nigeria',
        image: AirtelNig,
        styleLogo:'sm:w-[67px] h-auto'
      },
      
      {
        code: 'GLNG',
        value: 'Globacom Nigeria',
        image: GlobalCom,
        styleLogo:'sm:w-[39px] h-auto'
      },
    ]
     },

     { image: Kenya, value: 'Kenya',countryCode:'KEN', digits:9 , codeIso:'KE', code: '+254',
        operator:[
      {
        code: 'SAKE',
        value: 'Safaricom ',
        image: SafarieCom,
        styleLogo:'sm:w-[68px] h-auto'
      },
      {
        code: 'AIKE',
        value: 'Airtel Kenya',
        image: AirtelNig,
        styleLogo:'sm:w-[67px] h-auto'
      },
      
      {
        code: 'KTKE',
        value: 'Telkom Kenya',
        image: TelkomKen,
        styleLogo:'sm:w-[60px] h-auto'
      },
    ]
     },

     { image: Suisse, value: 'Suisse',countryCode:'CHE', digits:9 , codeIso:'CH', code: '+41',
        operator:[
      {
        code: 'KXCH',
        value: 'Swisscom Suisse',
        image: SwissCon,
        styleLogo:'sm:w-[68px] h-auto'
      },
      {
        code: 'KWCH',
        value: 'Sunrise Suisse',
        image: Sunrise,
        styleLogo:'sm:w-[41px] h-auto'
      },
      
      {
        code: 'W3CH',
        value: 'Salt Suisse',
        image: Salt,
        styleLogo:'sm:w-[56px] h-auto'
      },
    ]
     },

     { image: UK, value: 'Royaume-Uni',countryCode:'GBR', digits:10 , codeIso:'GB', code: '+44',
        operator:[
      {
        code: 'VFGB',
        value: 'Vodafone UK ',
        image: Vodafone,
        styleLogo:'sm:w-[73px] h-auto'
      },
      {
        code: 'O2GB',
        value: 'O2 UK',
        image: O2UK,
        styleLogo:'sm:w-[29px] h-auto'
      },
      
      {
        code: 'HTGB',
        value: 'Three (3 UK)',
        image: ThreeUK,
        styleLogo:'sm:w-[24px] h-auto'
      },
    ]
     },

      { image: Chine, value: 'Chine',countryCode:'CHN', digits:11 , codeIso:'CN', code: '+86',
        operator:[
      {
        code: 'C2CN',
        value: 'China Mobile',
        image: MobileCH,
        styleLogo:'sm:w-[70px] h-auto'
      },
      {
        code: 'C1CN',
        value: 'China Telecom',
        image: TelecomCH,
        styleLogo:'sm:w-[70px] h-auto'
      },
      
      {
        code: 'UMCN',
        value: 'China Unicom ',
        image: UnicomCH,
        styleLogo:'sm:w-[70px] h-auto'
      },
    ]
     },



    // { image: PrtIcon, value: "Portugal",countryCode:'', digits: 9 , codeIso:'PT', code: "+351",
    //     operator:[
    //    {
    //     code: 'MUPT',
    //     value: 'MEO',
    //     image: MEO,
    //     styleLogo:'sm:w-[53px] h-auto'
    //   },
       
    //    {
    //     code: 'VFPT',
    //     value: 'Vodafone',
    //     image: Vodafone,
    //     styleLogo:'sm:w-[74px] h-auto'
    //   },
    //   {
    //     code: 'NOPT',
    //     value: 'NOS',
    //     image: NOS,
    //     styleLogo:'sm:w-[62px] h-auto'
    //   }
    //     ]
    //  },
  ]
